export default __webpack_public_path__ + "static/media/symbol-defs.c7093e3f.svg";